import { type ReactNode, useCallback, useState } from 'react'

export type OpenModal = (
  content: ReactNode,
  onConfirm: () => void,
  isTransfer?: boolean,
) => void

export interface ModalState {
  content: ReactNode
  onConfirm: () => void
  isTransfer?: boolean
}

export function useModal() {
  const [modalState, setModalState] = useState<ModalState | null>(null)

  const openModal = useCallback<OpenModal>(
    (content, onConfirm, isTransfer = false) =>
      setModalState({ content, isTransfer, onConfirm }),
    [],
  )
  const closeModal = useCallback(() => setModalState(null), [])

  return { modalState, openModal, closeModal }
}
